/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsNegative } from '../../factoriesAny.js';
export var isNegativeDependencies = {
  typedDependencies,
  createIsNegative
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsNegative.generated.js
// module id = 185
// module chunks = 2